import { render, staticRenderFns } from "./fileCollection.vue?vue&type=template&id=50e06082&"
import script from "@viewJs/examRegisteation/fileCollection.js?vue&type=script&lang=js&"
export * from "@viewJs/examRegisteation/fileCollection.js?vue&type=script&lang=js&"
import style0 from "./fileCollection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports